import { render } from "./ResultsView.vue?vue&type=template&id=9873a62c&scoped=true"
import script from "./ResultsView.vue?vue&type=script&lang=js"
export * from "./ResultsView.vue?vue&type=script&lang=js"

import "./ResultsView.vue?vue&type=style&index=0&id=9873a62c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9873a62c"]])

export default __exports__